export default __webpack_public_path__ + "8090c42.png";